const types = [
    'SOCIAL_SECURITY_CARD',
    'SOCIAL_SECURITY_CARD_UNRESTRICTED',
    'RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED'
] as const;

type SocialSecurityCardDocumentType = typeof types[number];
export const isSocialSecurityCard = (documentType: string): documentType is SocialSecurityCardDocumentType => {
    return types.includes(documentType as SocialSecurityCardDocumentType);
};



// WEBPACK FOOTER //
// ./src/models/onboarding-review/ssn-details.ts